module.exports = __webpack_public_path__ + "img/marker-pv-icon-2x.20b3de1b.png";